module.exports = __webpack_public_path__ + "static/media/dgmt_logo_blue.cae412bf.jpg";